define('modules/profiles/models/profile.board.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function (_, Backbone, BaseModel) {
    var ProfileBoardModel = BaseModel.extend({
        base: 'identity/board',
        dnb: 'exclude',
        applyFilter: "false",
        pageSize: 20,
        page: 1,
        url:function(){
            var part = this.base;
            if(this.partyId != undefined ){
                part += '/' + this.partyId;
            }
            if(this.has('id')){
                part += '/' + this.get('id');
            }
            part += '?dnb=' + this.dnb + '&applyFilter=' + this.applyFilter + '&pageSize=' + this.pageSize + '&page=' + this.page;
            return window.utils.makeUrl('prospector/v1/' + part);
        },
        canModifyBoard:function(){
            return this.get('profileId') != 0;
        },
        canAddCard:function(){
            return this.get('typeId') == 1; //typeid 1 = key facts board
        },
        canAddArticle:function(){
            return this.get('typeId') == 7; //typeid 7 = saved articles board
        }
    });
    return ProfileBoardModel;
});

